import type { Tab } from '@revelio/data-access';

import { getGlobalAssistantRouteAccess } from '../global-ai-assistant/global-ai-assistant-access';

/**
 * Whether the viewer is entitled to the section a tutorial points at.
 *
 * Reuses the assistant's route-access map so a tutorial can never offer a page
 * the router would refuse to serve. That map keys some routes on their full
 * path (`/deliverables/data-enrichment`) and others on the route root
 * (`/report-builder`, which the Reports video targets as
 * `/report-builder/report_type`), and default-allows anything it does not
 * recognise — so walk the path from longest to shortest and take the first
 * denial rather than guessing which shape a given route uses.
 */
export const isTutorialSectionAllowed = (
  path: string | undefined,
  userTabs: Tab[]
): boolean => {
  if (!path) return true;

  const segments = path.split('/').filter(Boolean);
  for (let length = segments.length; length > 0; length--) {
    const candidate = `/${segments.slice(0, length).join('/')}`;
    if (!getGlobalAssistantRouteAccess(candidate, userTabs).allowed) {
      return false;
    }
  }

  return true;
};
